import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  dialog: {
    width: 400,
    borderRadius: 16,
    padding: '16px 32px 32px 32px',
  },
}));
